<template>
  <div class="container pb-5">

  <div class="d-flex align-items-center mb-4" data-aos="fade-right">
    <h2 class="underline-green font-montserrat-b m-0">{{ $t('services.process-verification-title') }}</h2>
    <img loading="lazy" class="icon-biosecurity" src="@/assets/icons/barn.svg"
    :alt="$t('alt.barn')">
  </div>

  <div class="row">
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-12 font-montserrat-r" data-aos="fade-right">
      <p class="m-0" v-html="$t('services.process-verification-description')"></p>

      <h5 class="text-center text-color-primary mt-5" v-html="$t('services.process-verification-label')"></h5>

      <div class="my-5 d-flex justify-content-center align-items-center gap-20">
        <div class="circle bg-gray">
          <PorkIcon />
        </div>
        <div class="circle bg-gray">
          <ChickenIcon />
        </div>
        <div class="circle bg-gray">
          <BeefIcon />
        </div>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12" data-aos="fade-left">
      <div class="row icons">
        <div class="col">
          <img loading="lazy" class="w-100" src="@/assets/icons/logo-ingles.svg"
          :alt="$t('alt.shield-animal-welfare')">
        </div>
        <div class="col">
          <img loading="lazy" class="w-100" src="@/assets/icons/animal-welfare-goat.svg"
          :alt="$t('alt.shield-animal-welfare')">
        </div>
        <div class="col">
          <img loading="lazy" class="w-100" src="@/assets/icons/animal-welfare-pig.svg"
          :alt="$t('alt.shield-animal-welfare')">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <img loading="lazy" class="w-100" src="@/assets/icons/logo-ingles-2.svg"
          :alt="$t('alt.shield-animal-welfare')">
        </div>
        <div class="col">
          <img loading="lazy" class="w-100" src="@/assets/icons/animal-welfare-cow2.svg"
          :alt="$t('alt.shield-animal-welfare')">
        </div>
        <div class="col">
          <img loading="lazy" class="w-100" src="@/assets/icons/animals-welfare.svg"
          :alt="$t('alt.shield-animal-welfare')">
        </div>
      </div>
    </div>
</div>
</div>
  <div class="row container-biosecurity py-5">
    <div class="col">
      <div class="container mb-5" data-aos="fade-right">
        <div class="d-flex align-items-start mb-3">
          <h2 class="underline-green font-montserrat-b">{{ $t('services.biosecurity-title') }}</h2>
          <img loading="lazy" class="icon-biosecurity" src="@/assets/icons/silo.svg"
          :alt="$t('alt.silo')">
        </div>
        <h6 class="font-noto-r">{{ $t('services.biosecurity-description') }}</h6>
      </div>

      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12" data-aos="fade-right">
          <img loading="lazy" class="w-100 image-biosecurity" src="@/assets/images/veterinarian-examining-pigs-at-pig-farm.jpg"
          :alt="$t('alt.services.veterinarian-pigs')">
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 px-5" data-aos="fade-left">
          <div class="container">
            <div class="row gx-5">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-stretch my-3">
                <BiosecurityItem
                  icon="porcine"
                  :title="$t('services.biosecurity-porcine-title')"
                  :description="$t('services.biosecurity-porcine-description')"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-stretch my-3">
                <BiosecurityItem
                  icon="protection"
                  :title="$t('services.biosecurity-protection-title')"
                  :description="$t('services.biosecurity-protection-description')"
                />
              </div>
            </div>

            <div class="row py-5">
              <div class="col text-center">
                <h3 class="font-montserrat-sb mb-3">{{ $t('services.cloverleaf-biosecurity-check-up') }}</h3>
                <h6 class="font-noto-r">{{ $t('services.our-50-point-description') }}</h6>
              </div>
            </div>

            <div class="container mb-5">
              <div class="row">
                <div class="col d-flex justify-content-center flex-row flex-lg-row flex-sm-column gap-30">
                  <div>
                    <TrebolText
                      v-for="item of biosecuritySkillsOne"
                      :key="item"
                      :text="item[language]"
                    />
                  </div>
                  <div>
                    <TrebolText
                      v-for="text of biosecuritySkillsTwo"
                      :key="text"
                      :text="text[language]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="container">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center font-noto-r">
            <div class="bg-gray bg-gray p-4 text-center">
              <p class="m-0" v-html="$t('services.text-info-alert')"></p>
            </div>

            <h5 class="font-montserrat-r text-center text-color-primary mt-5" v-html="$t('services.contact-text')"></h5>

            <div class="mt-3 d-flex justify-content-center align-items-center gap-20">
              <div class="circle bg-gray">
                <a href="https://wa.me/18166464005" target="_blank" :title="$t('title.phone-icon')">
                  <PhoneIcon />
                </a>
              </div>
              <div class="circle bg-gray">
                <MailColorIcon @click="openContactForm()"/>
              </div>
              <div class="circle bg-gray">
                <a href="https://zcal.co/cloverleafaws" target="_blank" :title="$t('title.calendar-icon')">
                  <CalendarColorIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import BiosecurityItem from './BiosecurityItem.vue'
import PhoneIcon from '@/components/Icons/PhoneSvg'
import MailColorIcon from '@/components/Icons/MailColorSvg'
import CalendarColorIcon from '@/components/Icons/CalendarColorSvg'
import PorkIcon from '@/components/Icons/PorkSvg'
import ChickenIcon from '@/components/Icons/ChickenSvg'
import BeefIcon from '@/components/Icons/BeefSvg'
import TrebolText from '@/components/TrebolText.vue'
import { useAppStore } from '@/stores/app'
import { useRouter } from 'vue-router'

export default {
  components: {
    TrebolText,
    BiosecurityItem,
    PhoneIcon,
    MailColorIcon,
    CalendarColorIcon,
    PorkIcon,
    ChickenIcon,
    BeefIcon
  },
  setup() {
    const { language } = useAppStore()

    const biosecuritySkillsOne = [
      {
        es: 'Alimentación y agua',
        en: 'Feed and water',
        pt: 'Alimentação e água'
      },
      {
        es: 'Eliminación de residuos',
        en: 'Waste disposal',
        pt: 'Eliminação de resíduos'
      },
      {
        es: 'Transportadores',
        en: 'Transporters',
        pt: 'Transportadores'
      },
      {
        es: 'Barreras',
        en: 'Barriers',
        pt: 'Barreiras'
      }
    ]

    const biosecuritySkillsTwo = [
      {
        es: 'Control de plagas',
        en: 'Pest control',
        pt: 'Controlo de pragas'
      },
      {
        es: 'Limpieza y saneamiento',
        en: 'Cleaning and sanitation',
        pt: 'Limpeza e saneamento'
      },
      {
        es: 'Mantenimiento de edificios',
        en: 'Building maintenance',
        pt: 'Manutenção de edifícios'
      },
      {
        es: 'Educación de los empleados',
        en: 'Employee education',
        pt: 'Educação dos empregados'
      }
    ]

    const router = useRouter()

    const openContactForm = () => {
      router.push({
        name: 'contact',
        hash: '#form-contact'
      })
    }

    return {
      openContactForm,
      biosecuritySkillsOne,
      biosecuritySkillsTwo,
      language
    }
  }
}
</script>

<style scoped>
  .container-biosecurity {
    background-color: #fafafa;
  }

  .image-biosecurity {
    object-fit: fill;
  }

  .icon-biosecurity {
    width: 50px;
    margin-left: 2em;
  }

  .circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.8em;
    cursor: pointer;
    transition: background 0.3s ease;
  }

  .circle:hover {
    background: var(--green-apple);
  }

  .brand-logo {
    object-fit: fill;
  }
</style>
